import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-cdr',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-cdr.component.html',
  styleUrl: './view-cdr.component.css'
})
export class ViewCDRComponent {

}
